export const fullAuthorPath = (path: string): string =>
  process.env.GATSBY_SITE_LANG === "pl" ? `/autor/${path}` : `/author/${path}`
